import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnboardGuard implements CanLoad, CanActivate {

  constructor(
    private router: Router
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean> | Promise<boolean> | boolean {
    const leuOnloard = localStorage.getItem('_leuOnboard');
    if (!leuOnloard) {
      this.router.navigate(['/onboarding']);
      return false;
    }
    return true;
  }

  canLoad(route: Route): boolean {
    const leuOnloard = localStorage.getItem('_leuOnboard');
    if (!leuOnloard) {
      this.router.navigate(['/onboarding']);
      return false;
    }
    return true;
  }
}
